export default defineNuxtPlugin((nuxtApp) => {
     addRouteMiddleware('redirect', (to) => {
      console.log('router::', to.path)
      if(to.path.startsWith('/@')) {
       // const username = to.path.slice(2) // remove leading '/@'
        //return navigateTo({ path: `/@${username}`, force: true, replace: true })
        return;
      }

      if (to.path.startsWith('/privacy-community')) {
        return
      }

      // old localized privacy paths redirect
      if (to.path.startsWith('/privacy-')) {
        return navigateTo({ path: '/privacy', force: true, replace: true })
      }

			if (to.path.startsWith('/link')) {
        return 
        //return navigateTo({ path: '/maintenance', force: true, replace: true })
      }

			if (to.path === '/sitemap-0.xml') {
				// OLD sitemap-0.xml redirect code to '301 Moved Permanently'
				return navigateTo('/sitemap.xml', { redirectCode: 301 })
			}
	
      return
    }, { global: true })
})
  